import { styled } from '@material-ui/core';

import { Image } from 'src/constants/dataTypes';

import { ImageRendererProps } from './types';

const StyledImageRendererContainer = styled('div')({
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
});

export const ImageRenderer = ({ value = [] }: ImageRendererProps) => (
  <StyledImageRendererContainer>
    {value.map((img: Image, idx: number) => (
      <img
        key={`${img.id}`}
        src={img.thumbnails ? img.thumbnails.small.url : img.url}
        alt={`${img.id} ${idx}`}
        width="45%"
      />
    ))}
  </StyledImageRendererContainer>
);
